import { IMilestoneTemplate } from "@/interfaces";

export const recursivelyUpdateMilestoneRadioProperty = (
  milestoneTemplates: IMilestoneTemplate[],
  updatedMilestone: IMilestoneTemplate,
  property: keyof IMilestoneTemplate
): IMilestoneTemplate[] => {
  if (!updatedMilestone[property]) return milestoneTemplates;

  const recursivelyIterate = (
    milestones: IMilestoneTemplate[]
  ): IMilestoneTemplate[] =>
    milestones.map((milestoneTemplate): IMilestoneTemplate => {
      const { id, secureProjectOnCompletion, childMilestones } =
        milestoneTemplate;
      const isChecked = updatedMilestone.id === id;

      const updatedMilestoneTemplate = {
        ...milestoneTemplate,
        [property]: isChecked,
        childMilestones: childMilestones && recursivelyIterate(childMilestones),
      };

      if (property === "shouldCompleteProject") {
        updatedMilestoneTemplate.secureProjectOnCompletion = isChecked
          ? secureProjectOnCompletion
          : false;
      }

      return updatedMilestoneTemplate;
    });

  return recursivelyIterate(milestoneTemplates);
};
